import makeBem from "Utils/makeBem";

export const homepageBem = makeBem("DashboardER");
export const costOfNewHireBem = makeBem("CostNewHire");
export const coverageModalBem = makeBem("CoverageModal");

export const getLastEnrolledCompanyPolicy = (account) => account.enrolledCompanyPolicy || account.upcomingCompanyPolicy || account.cancelledCompanyPolicy;
